import React, { PureComponent } from 'react';
import Text from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';
import Arrow from '../arrow';
import settings from '../../../data/get-settings';
import { PALETTE, ROUTES, KEY_CODE } from '../../../constants';
import Guid from '../../../utils/guid';
import OverrideBacklink from './disableBacklink.json';
import envConfig from '../../../../db-env-build';
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed'

const {
  DASHBOARD,
  NEW_DOMESTIC,
  DEBIT_ACCOUNT_LIST,
  DESTINATION,
  TX_SUMMARY,
  PAYMENT_STATUS
} = ROUTES.PAYMENT

export class PlainBackLink extends PureComponent {
  static defaultProps = {
    goBack: () => { },
  };

  setSelectedBankBlank = () => {
    const { goBack } = this.props;
    goBack();
  }

  OverrideBacklinkOnClicked = () => {
    const oGuid = Guid();
    this.props.onClickedEvent(oGuid);

  }

  paymentBack = () => {
    this.props.payments.setToggleConfirmModal(true)
  }

  multiSignApprovalBack = async () => {
    await this.props.payments.cancelTx()
  }
  genericAssetsBack=async()=>{
    const { goBack ,  resetSort ,setPageOffset} = this.props;
     await resetSort();
     await setPageOffset(0);
     await goBack();
  }

  orderReportBack = () => {
    const { reports: { adhoc: { setShowCancelModal } } } = this.props;
    setShowCancelModal(true);
  }
  componentDidUpdate(){
    if(document.querySelector('.back-link')){ 
      document.querySelector('.back-link').focus();
    }
  }

  render() {
    const { goBack, path, messages, push, auth: { isRMUserGroup }, app: { config: { enableStructuredAddress: structuredAddressEnabled } = {} } = {} } = this.props;
    const arPath = path.split('/');
    const prodPref = `/${envConfig.envConfig}`;
    const isPaymentDashboard = path === DASHBOARD || path === (prodPref + DASHBOARD)
    const isPaymentStatusPath = path === PAYMENT_STATUS || path === (prodPref + PAYMENT_STATUS)
    const isPaymentForm = path === NEW_DOMESTIC || path === (prodPref + NEW_DOMESTIC)
    const isSelectDebit = path === DEBIT_ACCOUNT_LIST || path === (prodPref + DEBIT_ACCOUNT_LIST)
    const isPaymentDestination = path === DESTINATION || path === (prodPref + DESTINATION)
    const isMultiSigApprovalPath = path === TX_SUMMARY || path === (prodPref + TX_SUMMARY)
    const isAdvices = path === '/advices' || path === (prodPref + '/advices')
    const isTradeComponent = path === ROUTES.TRADE.LIBRARY || path === (prodPref + ROUTES.TRADE.LIBRARY)
    const isGenericAssets = path === '/portfolios/genericAssets' || path === (prodPref + '/portfolios/genericAssets')
    const hideBack = !isTradeComponent && !isAdvices && (!isPaymentDashboard && (
      (settings.webfolder !== '' && arPath.length <= 3) ||
      (settings.webfolder === '' && arPath.length <= 2))
    );
    let onClick = (event) => {  if(isEnterorSpaceKeyPressed(event)){ 
      goBack()
    }}
    if (isPaymentDashboard) onClick = (event) => {  if(isEnterorSpaceKeyPressed(event)){
      push(ROUTES.PORTFOLIO.DASHBOARD) } 
    }
    if(isMultiSigApprovalPath) onClick = (event) => { if(isEnterorSpaceKeyPressed(event)){ 
      if(this.props.payments.isMultiSigApprovalFlow)  this.multiSignApprovalBack()
        goBack()}
    }
    if (isPaymentForm) onClick = (event) => { if(isEnterorSpaceKeyPressed(event)){ 
      this.paymentBack()}
    }
    if (isSelectDebit) onClick = (event) =>{ if(isEnterorSpaceKeyPressed(event)){
       push(DASHBOARD)
    }}
    if (isPaymentDestination) onClick = (event) => { if(isEnterorSpaceKeyPressed(event)){ 
      const isBeneficiaryBannerFlow = this.props.payments.isBeneficiaryBannerFlow;
      if (structuredAddressEnabled && isBeneficiaryBannerFlow) {
        // Beneficiary banner flow lands here from dashboard-page.js so back should return there, not the payments dashboard
        push(ROUTES.SUMMARY.DASHBOARD)
      } else {
        push(DASHBOARD)
      }
    }}
    if(this.props.hrmw.isUserBpListPage || this.props.paperless.isPaperlessSettingsPage) onClick = (event) => { if(isEnterorSpaceKeyPressed(event)){push(ROUTES.PROFILE.SETTINGS_ROUTE);}}
    if(this.props.hrmw.isMCDPage && this.props.hrmw.isAddContactDetailsFlow ) {
      this.props.paperless.isEdocumentFlow ? onClick = (event) => { if(isEnterorSpaceKeyPressed(event)){
        push(ROUTES.PAPERLESS.PAPERLESS_SETTINGS_ROUTE)}} : onClick = (event) => { if(isEnterorSpaceKeyPressed(event)){ push(ROUTES.PROFILE.USER_BP_LIST_ROUTE);
      }}
    }
   if(isGenericAssets) onClick=(event)=> {if(isEnterorSpaceKeyPressed(event)){ 
    this.genericAssetsBack()
    }}

    OverrideBacklink.paths.map((item) => {

      if (item === path || path === prodPref + ROUTES.TRADE.LIBRARY) {
        onClick = () => this.OverrideBacklinkOnClicked();
      }
    });

    if (hideBack || isPaymentStatusPath) {
      if (isRMUserGroup) {
        return (
          <div>
            <div className="read-only-banner" id="readOnlyBanner_appHeader_test" style={{ backgroundColor: PALETTE.primaryActive }}/>
            <Text className="read-only-banner-text" tertiary size="large">
              {messages['app.rmAccess.bankerAccess.readOnly']}
            </Text>
          </div>
        )
      }
      return <span>&nbsp;</span>;
    }

    const isOrderReport = path === ROUTES.REPORTS.ORDER_REPORT || path === (prodPref + ROUTES.REPORTS.ORDER_REPORT);  //WMCE-46391-resolving issue of back button not working in Asset positions 
    if(isOrderReport) onClick = (event) => {  if(isEnterorSpaceKeyPressed(event)){ 
      this.orderReportBack();
      }
    }

    return (
      <div className="back-link" {...(!isPaymentDashboard && { tabIndex: 0 })} onKeyDown={(e) => onClick(e)} onClick={() => onClick()} aria-label={messages['app.common.backBtn']}  role="button">
       {!isPaymentDashboard && <div style={{ display: 'inline-block', textAlign: 'center' }}>
          <span>
            <Arrow
              direction="left"
              width={9}
              height={14}
              color={PALETTE.secondaryActive}
              thickness={2}
              id="arrow_backLink_test"
            />
          </span>
          <Text className="link-text hide-for-small-only"
            testID="lbl_trade_backlink_text__test"
            accessibilityLabel="lbl_trade_backlink_text__test"
            secondary>
            {messages['app.common.backBtn']}
          </Text></div>}
        {isRMUserGroup &&
          <div style={{ display: 'inline-block', marginLeft: 10 , width: '260px' }}>
            <div className="read-only-banner" id="readOnlyBanner_appHeader_test" style={{ backgroundColor: PALETTE.primaryActive }}/>
            <Text className="read-only-banner-text" tertiary size="large">
              {messages['app.rmAccess.bankerAccess.readOnly']}
            </Text>
          </div >
        }
      </div >

    );
  }
}

export default createContainer(
  {
    $queries: {
      payments: { 
        isMultiSigApprovalFlow: true,
         cancelTx : { 
          $call: 'cancelTx'
        },
        setToggleConfirmModal: { $set: 'toggleConfirmModal' }, 
        setSelectedBeneficiaryBank: { $set: 'selectedBeneficiaryBank' }, 
        isSaveEnabled: {$set: 'isSaveEnabled'} , 
        templateName: {$set:'templateName'}, 
        isBeneficiaryBannerFlow: true
      },
      app: {
        config: {
          enableStructuredAddress: true,
        },
      },
      ui: {
        backlink: {
          onClickedEvent: { $set: 'onClicked' }
        },
        history: {
          canGoBack: true,
          currentLocation: {
            pathname: true,
          },
          push: { $call: 'push' },
          goBack: { $call: 'goBack' },
        },
        state: {
          portfolio: {
            genericAssets: {
               resetSort: { $call: 'resetSort' },
            }
          },
        },
        },
      
      auth: {
        isRMUserGroup: true
      },
      hrmw: {
        isUserBpListPage: true,
        isAddContactDetailsFlow: true,
        isMCDPage: true,
      },
      paperless: {
        isPaperlessSettingsPage: true,
        isEdocumentFlow: true,
      },
      portfolio:{
        genericAssets: {
          positions: {
            setPageOffset: { $set: 'pageOffset' },
          }  
        }
      },
      reports: {
        adhoc: {
          setShowCancelModal: { $set: 'showCancelModal' }
        }
      }
    },
  },
  ({ ui,portfolio, ...rest }) => ({
    canGoBack: ui.history.canGoBack,
    path: ui.history.currentLocation.pathname,
    goBack: ui.history.goBack,
    push: ui.history.push,
    onClickedEvent: ui.backlink.onClickedEvent,
    resetSort:ui.state.portfolio.genericAssets.resetSort,
    setPageOffset:portfolio.genericAssets.positions.setPageOffset,
    ...rest,
  })
)(PlainBackLink);
